// SafeCore Reports — State/Region Pesticide Report Configuration
// Add new states/countries here without touching Reports.js

const PESTICIDE_REPORT_CONFIGS = {
  NY: {
    label:        'New York (NY DEC)',
    country:      'US',
    agency:       'NY Department of Environmental Conservation',
    notes:        'NY DEC Commercial Pesticide Applicator — Annual Report of Pesticide Applications',
    licenseState: 'NY',
    recordRetention: '3 years',
  },
  NJ: {
    label:        'New Jersey (NJ DEP)',
    country:      'US',
    agency:       'NJ Department of Environmental Protection',
    notes:        'NJ DEP Pesticide Control Program — Commercial Pesticide Application Records',
    licenseState: 'NJ',
    recordRetention: '3 years',
  },
  FL: {
    label:        'Florida (FDACS)',
    country:      'US',
    agency:       'FL Department of Agriculture and Consumer Services',
    notes:        'FDACS Division of Agricultural Environmental Services — Pesticide Application Records',
    licenseState: 'FL',
    recordRetention: '2 years',
  },
  TX: {
    label:        'Texas (TDA)',
    country:      'US',
    agency:       'Texas Department of Agriculture',
    notes:        'Texas Department of Agriculture — Pesticide Application Records',
    licenseState: 'TX',
    recordRetention: '2 years',
  },
  CA: {
    label:        'California (CDPR)',
    country:      'US',
    agency:       'CA Department of Pesticide Regulation',
    notes:        'CDPR Pesticide Use Report (PUR) — Commercial Applicator Records',
    licenseState: 'CA',
    recordRetention: '3 years',
  },
  PA: {
    label:        'Pennsylvania (PDA)',
    country:      'US',
    agency:       'Pennsylvania Department of Agriculture',
    notes:        'PDA Bureau of Plant Industry — Pesticide Application Records',
    licenseState: 'PA',
    recordRetention: '2 years',
  },
  CT: {
    label:        'Connecticut (CAES)',
    country:      'US',
    agency:       'CT Agricultural Experiment Station',
    notes:        'CAES Pesticide Management Program — Commercial Application Records',
    licenseState: 'CT',
    recordRetention: '3 years',
  },
  PR: {
    label:        'Puerto Rico (DNER)',
    country:      'PR',
    agency:       'Departamento de Recursos Naturales y Ambientales',
    notes:        'DNER — Registro de Aplicaciones de Pesticidas Comerciales',
    licenseState: 'PR',
    recordRetention: '3 años',
  },
  ON: {
    label:        'Ontario (PMRA)',
    country:      'CA',
    agency:       'Pest Management Regulatory Agency',
    notes:        'Health Canada PMRA — Pest Control Products Application Records',
    licenseState: 'ON',
    recordRetention: '5 years',
  },
};

export const STATE_FORMATS = PESTICIDE_REPORT_CONFIGS;
export const STATE_OPTIONS = Object.keys(PESTICIDE_REPORT_CONFIGS);
export default PESTICIDE_REPORT_CONFIGS;
